angular.module('zc.zenclerkS')
  .component('zcsMonthlyReport', {
    templateUrl: '/templates/zenclerk_s/sites/reports/show/zcs_monthly_report.html',
    bindings: {
      project: '<',
      invoices: '<',
      month: '<'
    },
    controllerAs: 'vm',
    controller: zcsMonthlyReportController
  });


zcsMonthlyReportController.$inject = ['$element', '$translate', 'ZcsCampaignStats', 'ZcsIncentive', 'ZcsAccessStats', 'ZcsOemService', 'currencies'];
function zcsMonthlyReportController($element, $translate, ZcsCampaignStats, ZcsIncentive, ZcsAccessStats, ZcsOemService, currencies) {
  const vm = this;
  const CONSUMPTION_TAX = 1.1;
  const region = vm.project.region;

  // TODO: get the color from classes
  // colorPrimary = angular.element(".chart-primary").css('color')
  // colorSecondary = angular.element(".chart-secondary").css('color')
  const colorPrimary = '#1DD5A3';
  const colorSecondary = '#775BD6';
  const colorTertiary = '#ff5c79';

  function formatFraction(number) {
    return number / (10 ** vm.currency.fractionSize);
  }

  let dateRangeOfCurrentMonth = [];
  let today = moment.tz(region);

  vm.$onInit = () => {
    vm.svgContainerRelativeDailyConversion = d3.select($element.find('.chart-relative-conversion')[0]).append('svg');
    vm.svgContainerAbsoluteDailyConversion = d3.select($element.find('.chart-daily-conversion')[0]).append('svg');
    vm.svgContainerConversionPerDevice = d3.select($element.find('.chart-conversion-per-device')[0]).append('svg');
    vm.svgContainerCouponUsagePerDevice = d3.select($element.find('.chart-coupon-usage-per-device')[0]).append('svg');
    vm.svgContainerSameSessionConversion = d3.select($element.find('.chart-same-session-cv')[0]).append('svg');

    vm.campaignConversions = [];
    vm.mongoCampaigns = [];
    vm.monthlyDateKeys = [];
    vm.revenueData = {};
    vm.ZcsOemService = ZcsOemService;
    vm.currency = currencies[vm.project.currency];

    if(vm.project.sales_entity === 'appier_jp') {
      vm.campaignInvoicePrice = Math.floor(vm.invoices && vm.invoices.campaign_invoice_price_after_rounding_discount * CONSUMPTION_TAX);
    } else {
      vm.campaignInvoicePrice = Math.floor(vm.invoices && vm.invoices.campaign_invoice_price_after_rounding_discount);
    }

    if(isCurrentMonth()) {
      vm.today = moment.tz(region).format('YYYY-MM-DD HH:mm z');
    } else {
      vm.today = undefined;
    }

    vm.monthlyDateKeys = getMonthlyDateKeys(vm.month);

    let datesValueOf = _.map(vm.monthlyDateKeys, d => moment.tz(d, 'YYYY-MM-DD', region).valueOf());

    // set range to today's date for current month
    if(isCurrentMonth()) {
      dateRangeOfCurrentMonth = [
        _.head(datesValueOf),
        moment.tz(region).startOf('days').valueOf(),
      ];
    } else {
      dateRangeOfCurrentMonth = [_.head(datesValueOf), _.last(datesValueOf)];
    }

    const startAt = moment.tz(vm.month, 'YYYY-MM', region).toDate();
    const endAt = moment.tz(vm.month, 'YYYY-MM', region).endOf('month').toDate();

    return ZcsCampaignStats.find({
      apikey: vm.project.apikey,
      dimension: 'daily'
    }, {
      start_at: {
        $gte: startAt,
        $lt: endAt
      }
    }).then(res => {
      vm.revenueData = res;
      return ZcsAccessStats.getAccessStatsForSegment(vm.project.apikey, null, startAt, endAt);
    }).then(res => {
      vm.accessStats = res;
      return ZcsAccessStats.getPerDeviceAccessStatsForSegment(vm.project.apikey, null, startAt, endAt);
    }).then(res => {
      vm.perDeviceAccessStats = res;
      return ZcsIncentive.all(vm.project.id);
    }).then(incentives => {
      vm.incentivesByCode = _.groupBy(incentives, d => d.coupon_code);
      return ZcsAccessStats.getAccessStatsSameSession(vm.project.apikey, startAt, endAt);
    }).then(res => {
      vm.conversionSameSession = res;

      calculateCouponCost();
      createAbsoluteDailyConversionGraph();
      createRelativeDailyConversionGraph();
      createConversionPerDeviceGraph();
      if(vm.revenueData.length > 0) {
        createCouponUsagePerDeviceGraph();
      } else {
        createSameSessionConversionGraph();
      }
    });
  };

  function calculateCouponCost() {
    if(vm.revenueData.length === 0) return 0;

    const couponCostTotal = _.sum(_.map(vm.revenueData, 'coupon_cost'));

    vm.totalConversion = formatFraction(_.sumBy(vm.accessStats, 'conversion_price'));
    vm.zcTotalConversion = formatFraction(_.sum(_.map(vm.revenueData, 'effective_conversion_price')));

    if(vm.totalConversion) {
      vm.zcTotalConversionPercentage = (vm.zcTotalConversion / vm.totalConversion) * 100;
    } else {
      vm.zcTotalConversionPercentage = 0;
    }

    vm.profitPercent = vm.project.profit_percent || ZcsIncentive.getDefaultProfitPercent();
    vm.grossProfit = vm.zcTotalConversion * (vm.profitPercent / 100);
    vm.costOfGoods = vm.zcTotalConversion * (1 - vm.profitPercent / 100);
    vm.couponCost = formatFraction(couponCostTotal);
    vm.residualProfit = Math.round(vm.zcTotalConversion) -
      Math.round(vm.costOfGoods) -
      vm.campaignInvoicePrice -
      Math.round(vm.couponCost);
  }

  // create absolute daily conversion graph
  function createAbsoluteDailyConversionGraph() {

    const totalConversionData = [];
    const couponCodeConversionData = [];

    _.each(vm.monthlyDateKeys, date => {
      if(moment.tz(date, region).isAfter(today)) { return }

      const valueOfDate = moment.tz(date, 'YYYY-MM-DD', region).valueOf();
      const campaignData = _.filter(vm.revenueData, d => moment.tz(d.start_at, region).isSame(date, 'day'));
      if(campaignData.length) {
        couponCodeConversionData.push([
          valueOfDate,
          _.sumBy(campaignData, 'effective_conversion_price'),
        ]);
      } else {
        couponCodeConversionData.push([valueOfDate, 0]);
      }

      const totalData = _.find(vm.accessStats, d => moment.tz(d.start_at, region).isSame(date, 'day'));
      if(totalData) {
        let totalValue;
        if(campaignData) {
          totalValue =
            totalData.conversion_price -
            _.sumBy(campaignData, 'effective_conversion_price');
        } else {
          totalValue = totalData.conversion_price;
        }
        totalConversionData.push([valueOfDate, totalValue]);
      } else {
        totalConversionData.push([valueOfDate, 0]);
      }
    });

    nv.addGraph(() => {
      const chart = nv.models.stackedAreaChart()
        .margin({top: 30, right: 60, bottom: 50, left: 70})
        //.interpolate("cardinal") # rounded line
        .x(d => d[0])
        .y(d => formatFraction(d[1]))
        .showControls(false)
        .xDomain(dateRangeOfCurrentMonth)
        .color([colorPrimary, colorSecondary]);

      chart.xAxis
        .tickFormat(d => moment.tz(d, region).format('MM/DD'));

      chart.yAxis
        .tickFormat(d => vm.currency.symbol + d3.format(',f')(d) + vm.currency.suffix);

      vm.svgContainerAbsoluteDailyConversion.datum([
        {
          key: $translate.instant('sites.reports.show.zcsMonthlyReport.kuupon', { name: ZcsOemService.getName() }),
          values: couponCodeConversionData,
        },
        {
          key: $translate.instant('sites.reports.show.zcsMonthlyReport.sonohoka'),
          values: totalConversionData,
        }
      ])
        .call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  }

  // create relative daily conversion graph
  function createRelativeDailyConversionGraph() {

    const couponCodeConversionPercents = [];

    _.each(vm.monthlyDateKeys, date => {
      if(moment.tz(date, region).isAfter(today)) { return }
      const currentDate = moment.tz(date, 'YYYY-MM-DD', region).valueOf();

      const totalData = _.find(vm.accessStats, d => moment.tz(d.start_at, region).isSame(date, 'day'));
      const campaignData = _.filter(vm.revenueData, d => moment.tz(d.start_at, region).isSame(date, 'day'));

      if(totalData && campaignData) {
        const totalValue = totalData.conversion_price;
        const couponConversionPercent =
          totalValue > 0
            ? (100 * _.sumBy(campaignData, 'effective_conversion_price')) /
              totalValue
            : 0;
        couponCodeConversionPercents.push([currentDate, couponConversionPercent]);
      } else {
        couponCodeConversionPercents.push([moment.tz(date, 'YYYY-MM-DD', region).valueOf(), 0]);
      }
    }
    );

    nv.addGraph(() => {
      const chart = nv.models.stackedAreaChart()
        .showControls(false)
        //.interpolate("cardinal") # rounded line
        .margin({top: 30, right: 60, bottom: 50, left: 70})
        .x(d => d[0])
        .y(d => d[1])
        .xDomain(dateRangeOfCurrentMonth)
        .color([colorPrimary, 'rgba(0,0,0,0)']);
      chart.xAxis
        .tickFormat(d => moment.tz(d, region).format('MM/DD'));
      chart.yAxis
        .tickFormat(d => d3.format('f')(d) + '%');

      vm.svgContainerRelativeDailyConversion.datum([
        {
          key: $translate.instant('sites.reports.show.zcsMonthlyReport.kuupon', { name: ZcsOemService.getName() }),
          values: couponCodeConversionPercents,
        }
      ])
        .call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  }

  // create conversion per device
  function createConversionPerDeviceGraph() {
    // TODO: filter per device
    const data = getConversionsPerDevice(vm.perDeviceAccessStats);

    nv.addGraph(() => {
      const chart = nv.models.pieChart()
        .x(d => d.key)
        .y(d => d.value)
        .labelType('percent')
        .donut(true)
        .donutRatio(0.35)
        .color([colorPrimary, colorSecondary, colorTertiary]);

      chart.valueFormat(d => vm.currency.symbol + d3.format(',d')(d) + vm.currency.suffix);

      vm.svgContainerConversionPerDevice.datum(data)
        .call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  }

  // create coupon usage per device
  function createCouponUsagePerDeviceGraph() {
    // const data = vm.revenueData;
    const deviceData = {
      pc: 0,
      sp: 0,
      tablet: 0,
    };

    const perDeviceArrays = _.map(vm.revenueData, d => d.per_device_conversions);
    _.each(perDeviceArrays, d => {
      _.each(d, dd => {
        deviceData[dd.device] += dd.conversion_price;
      });
    });
    const data = _.chain(deviceData)
      .map((d, k) => {
        return {device: k, conversion_price: d};
      })
      .sortBy(d => d.device)
      .value();

    // check if all conversion_price values are 0
    if(!(_.map(data, 'conversion_price').every(d => d === 0))) {
      nv.addGraph(() => {
        const chart = nv.models.pieChart()
          .x(d => d.device)
          .y(d => d.conversion_price)
          .labelType('percent')
          .donut(true)
          .donutRatio(0.35)
          .color([colorPrimary, colorSecondary, colorTertiary]);

        chart.valueFormat(d => vm.currency.symbol + d3.format(',d')(d) + vm.currency.suffix);

        vm.svgContainerCouponUsagePerDevice.datum(data)
          .call(chart);

        nv.utils.windowResize(chart.update);

        return chart;
      });
    } else {
      d3.select($element.find('.chart-coupon-usage-per-device')[0]).remove();
      vm.noCouponConversions = true;
    }
  }

  function createSameSessionConversionGraph() {
    const sameSessionConversion = [];

    _.each(vm.monthlyDateKeys, date => {
      if(moment.tz(date, region).isAfter(today)) { return }
      const currentDate = moment.tz(date, 'YYYY-MM-DD', region).valueOf();

      const totalData = _.find(vm.conversionSameSession, d => moment.tz(d.start_at, region).isSame(date, 'day'));

      if(totalData) {
        const totalValue = totalData.conversion_count;
        sameSessionConversion.push([currentDate, totalValue]);
      } else {
        sameSessionConversion.push([moment.tz(date, 'YYYY-MM-DD', region).valueOf(), 0]);
      }
    }
    );

    nv.addGraph(() => {
      const chart = nv.models.lineChart()
        .margin({top: 30, right: 60, bottom: 50, left: 70})
        .x(d => moment(d[0]))
        .y(d => d[1])
        .xDomain(dateRangeOfCurrentMonth);

      chart.xAxis.tickFormat(d => moment.tz(d, region).format('MM/DD'));

      const conversionMax = Math.max(...vm.conversionSameSession.map(elt => elt.conversion_count));
      chart.yAxis.scale().domain([0, conversionMax]);

      vm.svgContainerSameSessionConversion.datum([{values: sameSessionConversion, key: $translate.instant('sites.reports.show.zcsMonthlyReport.conversion_count')}])
        .call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });

  }

  function getConversionsPerDevice(conversionData) {
    const data = _.chain(conversionData)
      .groupBy(d => d.device)
      .map((array, k) => {
        return {
          key: k,
          value: _.sumBy(array, dd => dd.conversion_price),
        };
      })
      .tap(array => {
        // need to add value: 0 to have always same color on pie charts
        if(!_.some(array, {key: 'pc'})) { array.push({key: 'pc', value: 0}) }
        if(!_.some(array, {key: 'sp'})) { array.push({key: 'sp', value: 0}) }
        if(!_.some(array, {key: 'tablet'})) { array.push({key: 'tablet', value: 0}) }
      })
      .sortBy(d => d.key)
      .value();

    return data;
  }

  function getMonthlyDateKeys(month) {
    const lastDayOfMonth = moment.tz(vm.month, 'YYYY-MM', region).endOf('month').date();
    // +1 because it's inclusive
    return _.map(_.range(1, lastDayOfMonth + 1), d => moment.tz(vm.month, 'YYYY-MM', region).date(d).format('YYYY-MM-DD'));
  }

  function isCurrentMonth() {
    return vm.month === moment.tz(region).format('YYYY-MM');
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/reports/show/zcs_monthly_report.directive.js